<template>
  <AuthWrapper>
    <p class="auth-notice">
      <language-setter />
      {{ $t('pages.register.have-an-account') }}
      <router-link to="/auth/login">{{ $t('pages.register.sign-in') }}</router-link>
    </p>
    <div class="auth-contents">
      <a-form name="register" :model="formState" @finish="handleSubmit" layout="vertical">
        <sdHeading as="h3"> {{ $t('pages.register.sign-up') }}</sdHeading>
        <a-form-item :label="$t('pages.register.name')" name="name">
          <a-input v-model:value="formState.name" :placeholder="$t('pages.register.name-placeholder')" required />
        </a-form-item>
        <a-form-item :label="$t('pages.register.surname')" name="surname">
          <a-input v-model:value="formState.surname" :placeholder="$t('pages.register.surname-placeholder')" required />
        </a-form-item>
        <a-form-item name="email" :label="$t('pages.register.email-address')">
          <a-input
            type="email"
            v-model:value="formState.email"
            :placeholder="$t('pages.register.email-placeholder')"
            required
          />
        </a-form-item>
        <a-form-item :label="$t('pages.register.password')" name="password">
          <a-input
            type="password"
            v-model:value="formState.password"
            :placeholder="$t('pages.register.password-placeholder')"
            required
          />
        </a-form-item>
        <a-form-item :label="$t('pages.register.password-confirm')" name="passwordConfirm">
          <a-input
            type="password"
            v-model:value="formState.passwordConfirm"
            :placeholder="$t('pages.register.password-confirm-placeholder')"
            required
          />
        </a-form-item>
        
        <div class="auth-form-action">
          <a-checkbox v-model:checked="formState.policy">
            {{ $t('pages.register.terms-of-service') }}
          </a-checkbox>
        </div>
        <div class="auth-form-action">
          <a-checkbox v-model:checked="formState.email_permit">
            {{ $t('pages.register.email-permit') }}
          </a-checkbox>
        </div>
        <a-form-item>
          <sdButton class="btn-create" htmlType="submit" type="primary" size="large" :disabled="isLoading">
            {{ isLoading ? $t('common.loading') : $t('pages.register.create-account') }}
          </sdButton>
        </a-form-item>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { AuthWrapper } from './style';
import axios from 'axios';
import { useRouter } from 'vue-router';
import LanguageSetter from './overview/LanguageSetter.vue';

export default {
  name: 'SignUp',
  components: { AuthWrapper, LanguageSetter },
  data() {
    return {
      formState: {
        name: '',
        surname: '',
        email: '',
        password: '',
        passwordConfirm: '',
        policy: false,
        email_permit : false
      },
      isLoading: false,
      router: useRouter(),
    };
  },
  methods: {
    handleSubmit() {
      if (this.formState.policy == false) {
        this.$message.error(this.$t('pages.register.policy-error'));
        return false;
      }
      this.isLoading = true;
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + this.$endpoints.auth_register, this.formState)
        .then((response) => {
          if (response.data.status === true) {
            this.isLoading = false;
            this.$message.success(this.$t('pages.register.register-success'));
            this.router.push('/auth/login');
          } else {
            this.isLoading = false;
            this.$message.error(response.data.message);
          }
        })
        .catch((e) => {
          this.isLoading = false;
          this.$message.error('Invalid Request');
        });
    },
  },
};
</script>
